import { LoginPageForm } from '../login-page-form';
import cls from './login-page.module.scss';

export const LoginPage = () => (
	<main className={cls.loginPage}>
		<LoginPageForm />
	</main>
);
